import React from 'react';
import PropTypes from 'prop-types';
import { AppShape } from 'next/entities/apps';
import {
  Icon,
  MoreMenu,
  MenuSection,
  ListRow,
  ExternalLink,
} from 'next/components/ui';
import { APP_ENABLED, getPlatformData } from './lib';

const AppMenu = ({ app, onOptionClick }) => {
  const { platform, state } = app;
  const { sdkUrl } = getPlatformData(platform);

  const handleEdit = () => onOptionClick('edit');
  const handleDisable = () => onOptionClick('disable');
  const handleEnable = () => onOptionClick('enable');

  return (
    <MoreMenu>
      <MenuSection>
        <ListRow prefix={<Icon icon="edit" />} onClick={handleEdit}>
          Edit name
        </ListRow>
        <ListRow prefix={<Icon icon="file-alt" />}>
          <ExternalLink href={sdkUrl}>Go to developer docs</ExternalLink>
        </ListRow>
        {state === APP_ENABLED ? (
          <ListRow
            onClick={handleDisable}
            prefix={<Icon icon="minus-circle" />}
          >
            Disable
          </ListRow>
        ) : (
          <ListRow onClick={handleEnable} prefix={<Icon icon="check-circle" />}>
            Enable
          </ListRow>
        )}
      </MenuSection>
    </MoreMenu>
  );
};

AppMenu.propTypes = {
  app: AppShape,
  onOptionClick: PropTypes.func,
};

export default AppMenu;
